import type { PropertyType } from "@/tailwind/tailwindUtils";
import type { ComboBoxOptionType } from "../components/input";
import { calculateNewClasses, extractVariant } from ".";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";

export const applyTailwindChangeToClasses = ({
  currentElementClasses,
  option,
  propertyType,
  variant,
}: {
  currentElementClasses: string[];
  option: ComboBoxOptionType;
  propertyType: PropertyType;
  variant?: string | null;
}) => {
  const classes = option.tailwind?.split(" ").filter(Boolean) || [];

  const tailwindClassesMap = useCodebaseStore.getState().tailwindClassesMap;

  // Helper function to clear existing classes for property type

  let newClasses: string[];
  let involvedClasses: Array<{
    tailwind: string;
    css: string;
    variant?: string | null;
  }>;

  if (classes.length === 1) {
    const { variant: actualVariant, className } = extractVariant(
      option.tailwind,
      variant,
    );

    // Use calculateNewClasses with the actual option to handle everything properly
    newClasses = calculateNewClasses({
      option: { tailwind: className, css: option.css },
      propertyType,
      oldClasses: currentElementClasses,
      tailwindClassesMap,
      variant: actualVariant,
    });

    involvedClasses = [{ ...option, variant: actualVariant }];
  } else {
    // Multiple classes - clear existing then add new
    newClasses = calculateNewClasses({
      option: null,
      propertyType,
      oldClasses: currentElementClasses,
      tailwindClassesMap,
      variant,
    });
    involvedClasses = [];

    for (const cls of classes) {
      const { variant: classVariant, className: actualClass } = extractVariant(
        cls,
        variant,
      );

      const classToAdd =
        classVariant && classVariant !== "default"
          ? `${classVariant}:${actualClass}`
          : actualClass;

      if (!newClasses.includes(classToAdd)) {
        newClasses.push(classToAdd);
      }

      involvedClasses.push({
        tailwind: actualClass,
        css: option.css,
        variant: classVariant,
      });
    }
  }

  return {
    newClasses,
    involvedClasses,
  };
};
